export default __webpack_public_path__ + "static/media/perl.1d680620.svg";